import * as React from "react";
import Box from "@mui/material/Box";
import { BorderAll } from "@mui/icons-material";

type PounceCatIconProps = {
//   src: string;
  size?: number;
  bgScale?: number;
  className?: string;
  borderRadius?: number | string;
};

export default function PounceCatIcon(props: PounceCatIconProps) {
  const { size = 40, bgScale = 1.55, className, borderRadius=0 } = props;

  const bgWidth = Math.round(size * bgScale);
  const bgHeight = Math.round(size * 0.95 * bgScale);

  const src="/pouncecat_7_export.jpg"; //png";

  const width = 2.5*size
  return (
    <Box
      className={className}
      sx={{
        // position: "relative",
        width: width,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 auto",
        //pl:0.5,
        //pr:0.25,
        marginRight: "-6px",
        borderRadius: borderRadius,
        }}
        >
      <img
        src={src}
        alt=""
        draggable={false}
        style={{
          position: "relative",
          zIndex: 1,
          width: `${width}px`,
          height: `${size}px`,
          objectFit:"fill", // "contain",//
          display: "block",
          userSelect: "none",
          opacity: 0.82,
          filter: "contrast(110%) brightness(120%)saturate(100%)",
          borderRadius: borderRadius,
        }}
      />
    </Box>
  );
}